import React from 'react';
import { BaseScatterChart } from '../Common/ScatterChart';
import { JsonPropsType } from '../../../component-loader';
import { formatData } from '../../../utils/deck';
import { GenericTableRawData } from './types';
import { ResponsiveWrapper } from '../Common/ResponsiveWrapper';

interface PortfolioMetricsExpectedColumns {
  DesvEst?: number;
  RetAc?: number;
  Beta?: number;
}
interface PortfolioMetricsScatterChartFormattedData {
  Cartera : PortfolioMetricsExpectedColumns;
  IPSA: PortfolioMetricsExpectedColumns;
  ACT: PortfolioMetricsExpectedColumns;
}

interface ChartData {
  standardDeviation: number;
  historicalReturn: number;
  name: string;
}

const MARGINS = {
  top: 0,
  right: 0,
  left: 10,
  bottom: 15,
};

export function PortfolioMetricsScatterChart(props: JsonPropsType) {
  const rawData = props.jsonObject as GenericTableRawData;

  // We don't want to parse Beta, because it is not a percentage!
  const cleanedData = formatData<PortfolioMetricsScatterChartFormattedData>({ rawData, parsingExceptions: ['Beta'] });
  const chartData = [
    {
      standardDeviation: cleanedData.IPSA.DesvEst,
      historicalReturn: cleanedData.IPSA.RetAc,
      name: 'IPSA',
    },
    {
      standardDeviation: cleanedData.Cartera.DesvEst,
      historicalReturn: cleanedData.Cartera.RetAc,
      name: `Cartera (β:${typeof cleanedData.Cartera.Beta === 'number' ? cleanedData.Cartera.Beta.toPrecision(2) : 'N/A'})`,
    },
  ];
  return (
    <ResponsiveWrapper minHeight={350}>

      <BaseScatterChart<ChartData>
        data={chartData as ChartData[]}
        xAxisDataKey="standardDeviation"
        yAxisDataKey="historicalReturn"
        yAxisLabel="Retorno Histórico (Anualizado)"
        xAxisLabel="Riesgo (Desviación Estándar)"
        margin={MARGINS}
      />
    </ResponsiveWrapper>
  );
}
